import { graphql } from '@/gql'

export const USER_RESET_PASSWORD = graphql(`
  mutation updateCredential($newPassword: String!) {
    updateCredential(input: { newPassword: $newPassword }) {
      clientMutationId
    }
  }
`)

export const USER_UPDATE = graphql(`
  mutation userUpdate(
    $id: UUID!
    $companyId: UUID
    $emailPassword: Boolean
    $companyAdmin: Boolean
    $isSystemUser: Boolean
    $canSignOnBehalfOf: Boolean
    $canLogin: Boolean
    $canLoginApp: Boolean
    $canLoginSso: Boolean
  ) {
    updateUserById(
      input: {
        id: $id
        patch: {
          companyId: $companyId
          emailPassword: $emailPassword
          companyAdmin: $companyAdmin
          isSystemUser: $isSystemUser
          canSignOnBehalfOf: $canSignOnBehalfOf
          canLogin: $canLogin
          canLoginApp: $canLoginApp
          canLoginSso: $canLoginSso
        }
      }
    ) {
      clientMutationId
    }
  }
`)

export const CREATE_SUPER_USER = graphql(`
  mutation createSuperUser(
    $userId: UUID!
    $companyWhitelist: [UUID]
    $companyBlacklist: [UUID]
    $createSuperUserAllowedUsers: [SuperUserAllowedUsersSuperUserIdForeignConnectionSuperUserAllowedUsersCreateInput!]
  ) {
    createSuperUser(
      input: {
        superUser: {
          userId: $userId
          companyWhitelist: $companyWhitelist
          companyBlacklist: $companyBlacklist
          superUserAllowedUsers: { create: $createSuperUserAllowedUsers }
        }
      }
    ) {
      superUser {
        id
      }
    }
  }
`)

export const UPDATE_SUPER_USER = graphql(`
  mutation updateSuperUserById(
    $id: UUID!
    $companyWhitelist: [UUID]
    $companyBlacklist: [UUID]
  ) {
    updateSuperUserById(
      input: {
        id: $id
        patch: {
          companyWhitelist: $companyWhitelist
          companyBlacklist: $companyBlacklist
        }
      }
    ) {
      clientMutationId
    }
  }
`)

export const DELETE_SUPER_USER = graphql(`
  mutation deleteSuperUserById($id: UUID!) {
    deleteSuperUserById(input: { id: $id }) {
      clientMutationId
    }
  }
`)

export const UPDATE_USER_LOCALE = graphql(`
  mutation updateUserLocale($locale: String!) {
    updateUserLocale(input: { locale: $locale }) {
      clientMutationId
    }
  }
`)
export const SET_USER_SETTING = graphql(`
  mutation setUserSetting($key: String!, $value: JSON!) {
    setUserSetting(input: { argKey: $key, argValue: $value }) {
      userSetting {
        id: key
        value
        userId
      }
    }
  }
`)

export const CHANGE_GOD_MODE_STATUS = graphql(`
  mutation changeGodModeStatus($userId: UUID!, $enable: Boolean!) {
    changeGodModeStatus(input: { userId: $userId, enable: $enable }) {
      user {
        id
        godmode
      }
    }
  }
`)

export const CREATE_SUPER_USER_ALLOWED_USERS = graphql(`
  mutation createSuperUserAllowedUsers(
    $superUserId: UUID
    $companyId: UUID
    $allowedUserIds: [UUID]
    $disallowedUserIds: [UUID]
  ) {
    createSuperUserAllowedUser(
      input: {
        superUserAllowedUser: {
          superUserId: $superUserId
          companyId: $companyId
          allowedUserIds: $allowedUserIds
          disallowedUserIds: $disallowedUserIds
        }
      }
    ) {
      superUserAllowedUser {
        id
        companyId
        allowedUserIds
        disallowedUserIds
      }
    }
  }
`)

export const UPDATE_SUPER_USER_ALLOWED_USERS = graphql(`
  mutation updateSuperUserAllowedUsers(
    $superUserId: UUID!
    $companyId: UUID!
    $allowedUserIds: [UUID]
    $disallowedUserIds: [UUID]
  ) {
    updateSuperUserAllowedUserBySuperUserIdAndCompanyId(
      input: {
        superUserId: $superUserId
        companyId: $companyId
        patch: {
          allowedUserIds: $allowedUserIds
          disallowedUserIds: $disallowedUserIds
        }
      }
    ) {
      superUserAllowedUser {
        id
        companyId
        allowedUserIds
        disallowedUserIds
      }
    }
  }
`)
